import { useAuthContext } from "@auth/context/Auth.context";
import { Button } from "@components/index";
import type React from "react";

type Props = {
  close: () => void;
};

const HeaderButtonLogout: React.FC<Props> = ({ close }) => {
  const { logout } = useAuthContext();

  return (
    <Button
      blockedWidth
      size="lg"
      content="start"
      buttonStyle="tertiary"
      icon="logout"
      label="Logout"
      onClick={() => {
        close();
        logout();
      }}
    />
  );
};

export default HeaderButtonLogout;
